import { render, staticRenderFns } from "./RangeFieldtype.vue?vue&type=template&id=4efc1283&"
import script from "./RangeFieldtype.vue?vue&type=script&lang=js&"
export * from "./RangeFieldtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports